import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab';
import { translate } from 'translations/i18n';

import { Avatar } from '@companycam/slab-web';
import { AccountGroupIcon } from 'components/shared/DesignSystem/Icons';
import Schema from 'javascripts/graphql/Schema';
import { getDisplayNameFromUser, initialsFromName } from 'helpers/strings';

// #region styled-components
function renderBackgroundColor(isFocused, isSelected) {
  if (isFocused) {
    return tokens.color_button_background_primary_le;
  } else if (isSelected) {
    return tokens.color_background_2_le;
  } else {
    return tokens.color_background_1_le;
  }
}

const StyledOption = styled.div`
  display: flex;
  align-items: center;
  padding: ${tokens.size_spacing_s}px ${tokens.size_spacing_m}px;
  cursor: pointer;
  color: ${(props) =>
    props.isFocused
      ? tokens.color_button_text_primary_le
      : tokens.color_link_secondary_le};
  background-color: ${(props) =>
    renderBackgroundColor(props.isFocused, props.isSelected)};
`;

const AvatarContainer = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: 48px;
`;

const Icon = styled(AccountGroupIcon)`
  display: block;
`;

const NameContainer = styled.div`
  margin-inline-start: ${tokens.size_spacing_s}px;
  display: flex;
`;
// #endregion

const SelectOption = ({
  innerRef,
  innerProps,
  isFocused,
  isSelected,
  value,
}) => {
  const { __typename, name, id, avatar } = value;
  const isGroup = __typename === Schema.Types.SearchGroup;
  const displayName = isGroup
    ? translate('projects.users.selectOption.groupNameFormat', {
        groupName: name,
      })
    : getDisplayNameFromUser(value);
  const initials = initialsFromName(displayName);

  return (
    <StyledOption
      data-testid={`assign-users-modal__option-${displayName}`}
      key={id}
      ref={innerRef}
      isFocused={isFocused}
      isSelected={isSelected}
      {...innerProps}
    >
      <AvatarContainer>
        {isGroup ? (
          <Icon
            size="medium"
            color={
              isFocused
                ? tokens.color_button_text_primary_le
                : tokens.color_link_subtle_le
            }
          />
        ) : (
          <Avatar
            fullName={name}
            imageSrc={avatar}
            alt={name}
            initials={initials}
            size="medium"
          />
        )}
      </AvatarContainer>
      <NameContainer>{displayName}</NameContainer>
    </StyledOption>
  );
};

SelectOption.propTypes = {
  innerRef: PropTypes.func,
  innerProps: PropTypes.object,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  value: PropTypes.object.isRequired,
};

export default SelectOption;
